const Index = {
    hooksTranslations: {
        addAll: 'All'
    }
}

const HooksTranslations = Object.assign(Index)

export default HooksTranslations;